import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";

class MultipleJobModal extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
        setCellProps: () => ({ style: { width: "5%" } }),
      },
    },
    { name: "serviceCode", label: "Kode Jasa/Job" },
    { name: "serviceName", label: "Nama Jasa/Job" },
    {
      name: "serviceCategory",
      label: "Service Category",
      options: {
        customBodyRender: (value) => value || "",
      },
    },
    {
      name: "variant.kodeVariant",
      label: "Kode Variant",
      options: {
        customBodyRender: (value) => value || "",
      },
    },
    { name: "variant.namaVariant", label: "Nama Variant" },
    {
      name: "",
      label: "Aksi",
      options: {
        customBodyRender: (_, { rowIndex }) => (
          <SimpleCheckBox
            id="checkbox_action"
            checked={this.state.unitChosen?.includes(rowIndex)}
            onChange={() => this.handlePilih(rowIndex)}
          />
        ),
      },
    },
  ];

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      loading: false,
      data: [],
      chosenData: [],
      unitChosen: [],
      noUnitChosen: false,
      job: null,
      optionSelected: [
        { label: "SEGMENT", value: "SEGMENT" },
        { label: "KODE_VARIAN", value: "KODE_VARIAN" },
      ],
      segemntOption: [],
      segment: null,
      variantOption: [],
      variant: null,
      jobName: null,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.fetchData(); // panggil default
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  fetchSegmentOptions = async () => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSegmen,
        menuName: "Master Promo H23",
        setError: this.props.setError,
      });
      if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        this.setState({
          segemntOption: response.data.data.map((item) =>
            mapToObjectDDL(item.segmentName, item.id)
          ),
        });
      }
    } catch (err) {
      console.error("Fetch segment gagal:", err);
    }
  };

  fetchVariantOptions = async () => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
        menuName: "Master Promo H23",
        setError: this.props.setError,
      });
      if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        this.setState({
          variantOption: response.data.data.map((item) =>
            mapToObjectDDL(item.kodeVariant, item.kodeVariant)
          ),
        });
      }
    } catch (err) {
      console.error("Fetch variant gagal:", err);
    }
  };

  handleSetValue = async ({ value, name }) => {
    if (name === "job") {
      this.setState(
        {
          job: value,
          segment: null,
          variant: null,
          segemntOption: [],
          variantOption: [],
        },
        async () => {
          if (value?.value === "SEGMENT") await this.fetchSegmentOptions();
          else if (value?.value === "KODE_VARIAN") await this.fetchVariantOptions();
        }
      );
      return;
    }
    this.setState({ [name]: value });
  };

  handlePilihSingleUnit = (index) => {
    this.setState({
      chosenData: [this.state.data[index]],
      unitChosen: [index],
    });
  };

  handlePilih = (index) => {
    if (this.props.isSingleSelectUnit) return this.handlePilihSingleUnit(index);

    this.setState((prev) => {
      const { unitChosen = [], chosenData = [] } = prev;
      const exists = unitChosen.includes(index);
      return {
        chosenData: exists
          ? chosenData.filter((_, i) => i !== index)
          : [...chosenData, this.state.data[index]],
        unitChosen: exists
          ? unitChosen.filter((i) => i !== index)
          : [...unitChosen, index],
      };
    });
  };

  handleSubmit = () => {
    if (this.state.chosenData.length > 0)
      this.props.onSubmit(
        this.props.isSingleSelectUnit
          ? this.state.chosenData[0]
          : this.state.chosenData
      );
    else this.handleNoUnitChosen();
  };

  fetchData = async (segment = null, variant = [], jobName = null) => {
    this.handleTriggerLoading();

    try {
      const payload = {
        segment: segment?.value ?? null,
        variant: Array.isArray(variant) && variant.length
          ? variant.map((v) => v.value)
          : [],
        jobName: jobName || null,
      };

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getServicePromoH23,
        menuName: "Master Promo H23",
        setError: this.props.setError,
        args: payload,
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        // Flatten object columns untuk aman di tabel
        const flatData = res.data.data.map((item) => ({
          ...item,
          serviceCategory: item.serviceCategory?.value || "",
          kodeVariant: item.kodeVariant?.value || "",
        }));
        if (this._isMounted) this.setState({ data: flatData });
      } else if (this._isMounted) {
        this.setState({ data: [] });
      }
    } catch (err) {
      console.error("Search gagal:", err);
      if (this._isMounted) this.setState({ data: [] });
    } finally {
      if (this._isMounted) this.handleTriggerLoading();
    }
  };

  handleSearch = async () => {
    const { segment, variant, jobName } = this.state;
    await this.fetchData(segment, variant, jobName);
  };

  handleNoUnitChosen = () => {
    this.setState((prev) => ({ ...prev, noUnitChosen: !prev.noUnitChosen }));
  };

  handleValueChange = (name, value) => this.setState({ [name]: value });

  render() {
    const { job } = this.state;
    return (
      <>
        <SimpleModal
          title={"Multiple Job"}
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          content={
            <ModalContainer>
              <FlexView className={"margin-left-10px margin-bottom-20px"}>
                <FlexView column>
                  <div className="grid grid-2x gap-20px">
                    <div id="grid-1">
                      <div style={{ display: "flex" }}>
                        <p style={{ marginRight: 20, marginTop: 27 }}>Pilih :</p>
                        <div style={{ width: 250, marginLeft: 40, marginTop: 13 }}>
                          <SimpleDDL
                            id="select_options_job"
                            box="search"
                            name="job"
                            isClearable
                            options={this.state.optionSelected}
                            value={this.state.job}
                            onChange={(value) =>
                              this.handleSetValue({ value, name: "job" })
                            }
                          />
                        </div>
                      </div>

                      <div style={{ display: "flex" }}>
                        <p style={{ marginRight: 20, marginTop: 27 }}>Nama Job :</p>
                        <div style={{ width: 250, marginTop: 13 }}>
                          <SimpleInput
                            id="input_text_job_name"
                            name="jobName"
                            value={this.state.jobName}
                            onChange={({ target }) =>
                              this.handleValueChange(target.name, target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div id="grid-2">
                      {job === null && (
                        <div id="grid-segment">
                          <div style={{ width: 250, marginLeft: 10, marginTop: 18 }}>
                            <SimpleDDL id="select_options_job" box="search" name="" readOnly />
                          </div>
                        </div>
                      )}

                      {job?.value === "SEGMENT" && (
                        <div id="grid-segment">
                          <div style={{ width: 250, marginLeft: 10, marginTop: 18 }}>
                            <SimpleDDL
                              id="select_options_segment"
                              box="search"
                              name="segment"
                              options={this.state.segemntOption}
                              value={this.state.segment}
                              onChange={(value) =>
                                this.handleSetValue({ value, name: "segment" })
                              }
                            />
                          </div>
                        </div>
                      )}

                      {job?.value === "KODE_VARIAN" && (
                        <div id="grid-variant">
                          <div style={{ width: 250, marginLeft: 10, marginTop: 18 }}>
                            <SimpleDDL
                              id="select_options_variant"
                              box="multiselect"
                              name="variant"
                              options={this.state.variantOption}
                              value={this.state.variant}
                              onChange={(value) =>
                                this.handleSetValue({ value, name: "variant" })
                              }
                            />
                          </div>
                        </div>
                      )}

                      <div style={{ marginTop: 37 }}>
                        <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                      </div>
                    </div>
                  </div>
                </FlexView>
              </FlexView>

              <SimpleDataTable
                data={this.state.data}
                columns={this.tableColumns}
                options={{ serverSide: false }}
                rowsPerPage={10}
              />

              <FlexView hAlignContent="right" className="margin-top-15px">
                <SimpleButton onClick={this.handleSubmit}>Pilih</SimpleButton>
              </FlexView>
            </ModalContainer>
          }
        />

        {this.state.noUnitChosen && (
          <SimpleModal
            title={"No Unit Chosen"}
            visible={this.state.noUnitChosen}
            onClickClose={this.handleNoUnitChosen}
            content={
              <ModalContainer>
                <p>No Unit Chosen</p>
              </ModalContainer>
            }
          />
        )}

        {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
      </>
    );
  }
}

export default MultipleJobModal;
